<p-card>
    <h1
        class="fs-5"
        i18n="@@settingsOpenAiTitle"
    >OpenAI-Integration</h1>
    <p
        class="text-muted"
        i18n="@@settingsOpenAiDescription"
    >Hinterlegt den OpenAI-API-Key für KI-Funktionen in dieser Anwendung.</p>

    <p *ngIf="openAiConfigured">
        <i class="ri-checkbox-circle-line text-success me-1"></i>
        <span i18n="@@settingsOpenAiConfigured">Ein API-Key ist hinterlegt.</span>
    </p>
    <p *ngIf="!openAiConfigured">
        <i class="ri-close-circle-line text-danger me-1"></i>
        <span i18n="@@settingsOpenAiNotConfigured">Es ist noch kein API-Key hinterlegt.</span>
    </p>

    <div class="form-group mb-3">
        <label
            class="form-label"
            for="openAiApiKey"
            *ngIf="!openAiConfigured"
            i18n="@@settingsOpenAiKeyLabel"
        >OpenAI-API-Key</label>
        <label
            class="form-label"
            for="openAiApiKey"
            *ngIf="openAiConfigured"
            i18n="@@settingsOpenAiKeyLabelReplace"
        >Neuen API-Key eintragen (ersetzt den bestehenden)</label>
        <input
            id="openAiApiKey"
            type="password"
            class="form-control"
            [(ngModel)]="openAiApiKey"
            placeholder="sk-…"
            autocomplete="off"
        >
    </div>

    <button
        pButton
        class="me-2"
        [loading]="saving"
        [disabled]="!openAiApiKey"
        (click)="saveOpenAiApiKey()"
        i18n="@@settingsOpenAiSave"
    >Speichern</button>
    <button
        pButton
        [outlined]="true"
        severity="danger"
        *ngIf="openAiConfigured"
        (click)="clearOpenAiApiKey()"
        i18n="@@settingsOpenAiClear"
    >Key entfernen</button>
</p-card>

<p-card styleClass="mt-3">
    <h1
        class="fs-5"
        i18n="@@settingsFalTitle"
    >fal.ai-Integration</h1>
    <p
        class="text-muted"
        i18n="@@settingsFalDescription"
    >Hinterlegt den fal.ai-API-Key für die Bildgenerierung der Kacheln (Icon und Titelbild).</p>

    <p *ngIf="falConfigured">
        <i class="ri-checkbox-circle-line text-success me-1"></i>
        <span i18n="@@settingsFalConfigured">Ein API-Key ist hinterlegt.</span>
    </p>
    <p *ngIf="!falConfigured && falEnvFallback">
        <i class="ri-information-line text-primary me-1"></i>
        <span i18n="@@settingsFalEnvFallback">Kein Key hinterlegt — es wird der Key aus der Server-Umgebung (FAL_KEY) verwendet.</span>
    </p>
    <p *ngIf="!falConfigured && !falEnvFallback">
        <i class="ri-close-circle-line text-danger me-1"></i>
        <span i18n="@@settingsFalNotConfigured">Es ist noch kein API-Key hinterlegt. Die Bildgenerierung ist deaktiviert.</span>
    </p>

    <div class="form-group mb-3">
        <label
            class="form-label"
            for="falApiKey"
            *ngIf="!falConfigured"
            i18n="@@settingsFalKeyLabel"
        >fal.ai-API-Key</label>
        <label
            class="form-label"
            for="falApiKey"
            *ngIf="falConfigured"
            i18n="@@settingsOpenAiKeyLabelReplace"
        >Neuen API-Key eintragen (ersetzt den bestehenden)</label>
        <input
            id="falApiKey"
            type="password"
            class="form-control"
            [(ngModel)]="falApiKey"
            autocomplete="off"
        >
    </div>

    <button
        pButton
        class="me-2"
        [loading]="falSaving"
        [disabled]="!falApiKey.trim()"
        (click)="saveFalApiKey()"
        i18n="@@settingsOpenAiSave"
    >Speichern</button>
    <button
        pButton
        [outlined]="true"
        severity="danger"
        *ngIf="falConfigured"
        (click)="clearFalApiKey()"
        i18n="@@settingsOpenAiClear"
    >Key entfernen</button>
</p-card>
